import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from './App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faTimes, faBars, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { MonaRoles } from '../constant';

const SIDEBAR_COLLAPSE_KEY = 'sidebar_collapsed';

const LeftNavbar = () => {
  const location = useLocation();
  const LSToken = localStorage.getItem('token');
  const AxiosHeaders = { headers: { Authorization: `Bearer ${LSToken}` } };

  const [LSUserRole] = useState(localStorage.getItem('user_role'));
  const [permissionList, setPermissionList] = useState();
  const [userDashboardLink, setuserDashboardLink] = useState();
  const [alert, setAlert] = useState('');
  const [LSUserId] = useState(localStorage.getItem('user_id'));
  const [expanded, setExpanded] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === '1'
  );

  const closeMobileMenu = useCallback(() => setExpanded(false), []);

  const AnnouncementAlert = async () => {
    let userID = LSUserId;
    let Url = `${BASE_URL}/announcement/announcementStatus/${userID}`;
    if (LSToken) {
      const response = await axios.get(Url, AxiosHeaders);
      if (response.status === 200 && response.data.message === 'Announcements is Active') {
        localStorage.setItem('alert_announcement', '*');
        setAlert(localStorage.getItem('alert_announcement'));
      }
    }
  };

  const AnnouncementAlertset = async () => {
    let userID = LSUserId;
    let Url = `${BASE_URL}/announcement/announcementStatus/${userID}`;
    if (LSToken) {
      const response = await axios.put(Url, {}, AxiosHeaders);
      if (response.status === 200 && response.data.status === 'success') {
        localStorage.removeItem('alert_announcement');
        setAlert(localStorage.getItem('alert_announcement'));
      }
    }
  };

  const fetchPermissionList = async () => {
    let menu_list = JSON.parse(localStorage.getItem('menu_list'));
    if (LSUserRole !== MonaRoles.guardian) {
      menu_list = menu_list.filter((d) => d.controller.controller_label !== 'Child Enrolment');
    }
    if (LSUserRole === MonaRoles.guardian) {
      menu_list = menu_list.filter((d) => d.controller.controller_label !== 'User Management');
    }
    menu_list = menu_list.map((d) => {
      if (d.controller.controller_label === 'Child Enrolment') {
        return {
          controller: {
            id: d.controller.id,
            sequence: d.controller.sequence,
            actions: d.controller.actions,
            controller_icon: d.controller.controller_icon,
            controller_name: d.controller.controller_name,
            controller_label: d.controller.controller_label,
            show_in_menu: d.controller.show_in_menu,
            menu_link: `children/${LSUserId}`,
          },
        };
      }
      return d;
    });

    let sortedData = menu_list.sort(function (a, b) {
      let x = a.controller.sequence;
      let y = b.controller.sequence;
      if (x > y) {
        return 1;
      }
      if (x < y) {
        return -1;
      }
      return 0;
    });

    setPermissionList(sortedData.filter((permission) => permission.controller.show_in_menu === true));
  };

  useEffect(() => {
    var user_dashboar_link = '';
    if (LSUserRole === 'coordinator') user_dashboar_link = 'coordinator-dashboard';
    else if (LSUserRole === MonaRoles.franchisorAdmin) user_dashboar_link = 'franchisor-dashboard';
    else if (LSUserRole === MonaRoles.franchiseeAdmin) user_dashboar_link = 'franchisee-dashboard';
    else if (LSUserRole === MonaRoles.coordinator) user_dashboar_link = 'coordinator-dashboard';
    else if (LSUserRole === MonaRoles.educator) user_dashboar_link = 'educator-dashboard';
    else if (LSUserRole === MonaRoles.guardian) user_dashboar_link = 'parents-dashboard';
    else {
      user_dashboar_link = '/';
    }
    setuserDashboardLink(user_dashboar_link);

    fetchPermissionList();
    AnnouncementAlert();
  }, []);

  useEffect(() => {
    if (window.location.href.split('/').pop() === 'announcements') {
      AnnouncementAlertset();
    }
  }, [window.location.href]);

  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', sidebarCollapsed);
    localStorage.setItem(SIDEBAR_COLLAPSE_KEY, sidebarCollapsed ? '1' : '0');
    return () => document.body.classList.remove('sidebar-collapsed');
  }, [sidebarCollapsed]);

  useEffect(() => {
    document.body.classList.toggle('sidebar-mobile-open', expanded);
    return () => document.body.classList.remove('sidebar-mobile-open');
  }, [expanded]);

  useEffect(() => {
    if (!expanded) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeMobileMenu();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [expanded, closeMobileMenu]);

  const isLinkActive = (toPath) => {
    const current = location.pathname.replace(/\/$/, '') || '/';
    const target = `/${toPath}`.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
    return current === target || current.startsWith(`${target}/`);
  };

  const collapseSidebar = () => setSidebarCollapsed(true);
  const expandSidebar = () => setSidebarCollapsed(false);

  return (
    <>
      {createPortal(
        <button
          type="button"
          className={`sidebar-expand-btn${sidebarCollapsed ? ' is-visible' : ''}`}
          onClick={expandSidebar}
          aria-label="Open sidebar"
          title="Open sidebar"
          aria-hidden={!sidebarCollapsed}
          tabIndex={sidebarCollapsed ? 0 : -1}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>,
        document.body
      )}

      <div className="sidebar-inner">
        <div className="sidebar-header">
          <div className="logo-column text-center">
            <Navbar.Brand href={`/${userDashboardLink}`}>
              <img src="/img/logo-ico.png" alt="Mona CIP" />
            </Navbar.Brand>
          </div>
          <button
            type="button"
            className="sidebar-desktop-close"
            onClick={collapseSidebar}
            aria-label="Close sidebar"
            title="Close sidebar"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        </div>

        <Navbar expand="xl" expanded={expanded} onToggle={setExpanded} className="sidebar-navbar">
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="sidebar-mobile-toggle" />

          {expanded && (
            <div
              className="sidebar-backdrop"
              onClick={closeMobileMenu}
              onKeyDown={(e) => e.key === 'Escape' && closeMobileMenu()}
              role="button"
              tabIndex={0}
              aria-label="Close menu overlay"
            />
          )}

          <Navbar.Collapse id="basic-navbar-nav">
            <div className="sidebar-drawer-head">
              <span className="sidebar-drawer-title">Menu</span>
              <button
                type="button"
                className="sidebar-close-btn"
                onClick={closeMobileMenu}
                aria-label="Close sidebar"
                title="Close sidebar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <Nav className="mr-auto w-100 sidebar-nav">
              {permissionList &&
                permissionList.map((permission, index) => {
                  const menuKey =
                    permission?.controller?.id ??
                    permission?.controller?.controller_name ??
                    index;
                  const toPath =
                    permission.controller.controller_name == 'overview'
                      ? userDashboardLink
                      : permission.controller.menu_link;
                  const active = isLinkActive(toPath);

                  return (
                    <Nav.Link
                      key={menuKey}
                      as={Link}
                      to={`/${toPath}`}
                      className={active ? 'active' : undefined}
                      onClick={closeMobileMenu}
                    >
                      <span>
                        <i className={`ico ${permission.controller.controller_icon}`}>&nbsp;</i>
                        {permission.controller.controller_label === 'Announcements' ? (
                          <div
                            className="sidebar-announcement-label"
                            onClick={AnnouncementAlertset}
                          >
                            {permission.controller.controller_label}
                            <span className="sidebar-alert-dot">
                              {alert === '*' && (
                                <FontAwesomeIcon icon={faCircle} style={{ fontSize: '7px' }} />
                              )}
                            </span>
                          </div>
                        ) : (
                          permission.controller.controller_label
                        )}
                      </span>
                    </Nav.Link>
                  );
                })}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <footer className="sidebar-footer ico-column text-center">
          <div className="sidebar-footer-art">
            <img src="/img/kid-art.svg" alt="" />
          </div>
          <p className="sidebar-footer-copy">© {new Date().getFullYear()} Mona CIP</p>
        </footer>
      </div>
    </>
  );
};

export default LeftNavbar;
